import React from 'react'
import { useGetRoleAccessConfig } from 'src/app/AppAuth/AppAuth.hooks'
import { useInAudit } from 'src/context/AuditContext'
import { useParams } from 'react-router-dom'
import { MenuItemContainer, MenuItemLink } from './FloatingMenu.styles'

export const FloatingNavMenuItem = ({
  title,
  isActive,
  onClick,
  route,
}: {
  title: string
  isActive: boolean
  onClick: () => void
  route: string
}): JSX.Element => {
  const {
    routeConfig: { hideNavRoutes, explicitAllowRoutes, restrictToAuditView },
  } = useGetRoleAccessConfig()
  const { auditId } = useInAudit()

  const hideRoute = hideNavRoutes.includes(route)

  const ccHideRoute =
    restrictToAuditView && !auditId && !explicitAllowRoutes.includes(route)
  if (hideRoute || ccHideRoute) {
    return <></>
  }
  return (
    <FloatingMenuItem
      title={title}
      isActive={isActive}
      onClick={onClick}
      route={route}
    />
  )
}

export const FloatingMenuItem = ({
  title,
  isActive,
  onClick,
  route,
}: {
  title: string
  isActive?: boolean
  onClick: () => void
  route?: string
}): JSX.Element => {
  const { pageContext } = useParams()
  return (
    <MenuItemContainer
      onClick={(e) => {
        e.preventDefault()
        onClick()
      }}
    >
      <MenuItemLink isActive={isActive} href={`/${pageContext}/${route}`}>
        {title}
      </MenuItemLink>
    </MenuItemContainer>
  )
}
